import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { ReferenceDataService } from '../../../../services/reference-data/reference-data.service';
var PlatformReacheComponent = /** @class */ (function () {
    function PlatformReacheComponent(pdfService, referenceData, userService) {
        this.pdfService = pdfService;
        this.referenceData = referenceData;
        this.userService = userService;
        this.platforms = [];
        this.forPayingUser = false;
    }
    Object.defineProperty(PlatformReacheComponent.prototype, "showFallbackView", {
        get: function () {
            return this.platforms.length === 0 || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformReacheComponent.prototype, "platformList", {
        get: function () {
            var _this = this;
            if (!Array.isArray(this.activePlatforms) || this.activePlatforms.length === 0) {
                return [];
            }
            var activePlatformNames = this.referenceData.platforms.filter(function (p) { return _this.activePlatforms.indexOf(p.id) >= 0; })
                .map(function (plr) { return plr.name.toLowerCase(); });
            return this.platforms.filter(function (p) { return activePlatformNames.indexOf(p.name.toLowerCase()) >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    PlatformReacheComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(PlatformReacheComponent.COMPONENT_NAME);
    };
    PlatformReacheComponent.COMPONENT_NAME = 'PlatformReacheComponent';
    return PlatformReacheComponent;
}());
export { PlatformReacheComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/platform-reache/platform-reache.component.ts.pre-build-optimizer.js